import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/Facebook_Logo_Secondary.png'
import _imports_1 from '../library/assets/Instagram_Glyph.png'
import _imports_2 from '../library/assets/LI-In.png'


const _withScopeId = n => (_pushScopeId("data-v-7a9395af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-banner" }
const _hoisted_2 = { class: "p-1" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "social-icon"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "p-1" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "social-icon"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "p-1" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "social-icon"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Follow us on Social Network')), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["asahi-social-banner-container", !_ctx.isLoggedIn && 'd-sm-flex justify-content-sm-start justify-content-center'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('fb').url,
          target: "_blank",
          title: "Facebook",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.navigateToPath(_ctx.getLinkByName('fb').url, 'Facebook')), ["prevent"]))
        }, _hoisted_5, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('instagram').url,
          target: "_blank",
          title: "Instagram",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateToPath(_ctx.getLinkByName('instagram').url, 'Instagram')), ["prevent"]))
        }, _hoisted_9, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('linkedin').url,
          target: "_blank",
          title: "LinkedIn",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.navigateToPath(_ctx.getLinkByName('linkedin').url, 'LinkedIn')), ["prevent"]))
        }, _hoisted_13, 8, _hoisted_11)
      ])
    ], 2)
  ]))
}